import { menuAdmin, menuAgents } from "constants/menu";
import { Fragment, useCallback, useEffect, useState } from "react";
import Menu from "./Menu";
import { Link } from "react-router-dom";
import { getData } from "actions";
import { useDispatch, useSelector } from "react-redux";
import { API_URL_companysetting } from "constants/api";
import { companySettingReducers } from "redux/companySettingSlice";

const Sidebar = ({ sideOpen, setSideOpen, admin }) => {
  const [openHover, setOpenHover] = useState(false);
  const dispatch = useDispatch();
  const { getCompanySettingResult } = useSelector(
    (state) => state.companySetting
  );
  const get = useCallback(
    async (params) => {
      getData(
        API_URL_companysetting,
        params,
        { dispatch, redux: companySettingReducers },
        "GET_COMPANYSETTING"
      );
    },
    [dispatch]
  );
  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    get(params);
  }, [get]);

  const handleToPortal = () => {
    window.location.href = "/";
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Fragment>
      {/* backdrop */}
      <div
        onClick={() => setSideOpen(!sideOpen)}
        className={`fixed w-screen h-screen sm:hidden z-50 bg-black transition-opacity duration-700 ${
          sideOpen ? "opacity-40" : "opacity-0 pointer-events-none"
        }`}
      ></div>

      <aside
        onMouseEnter={() => !sideOpen && setOpenHover(true)}
        onMouseLeave={() => !sideOpen && setOpenHover(false)}
        className={` bg-sky-800 text-white z-50 dark:bg-neutral-800 dark:text-neutral shadow h-screen top-0 flex flex-col transition-[width, position] duration-500 ${
          sideOpen
            ? "left-0 w-60 absolute sm:static"
            : "-left-60 sm:left-0 w-14 absolute"
        } ${openHover ? "w-60" : ""}`}
      >
        <Link
          onClick={handleToPortal}
          className="flex items-center justify-center h-16 px-2 mb-4 hover:dark:bg-neutral-800 dark:text-neutral"
        >
          {getCompanySettingResult.logo &&
            getCompanySettingResult.use_logo === 1 && (
              <img
                src={getCompanySettingResult.logo}
                className="w-full h-3/4 hover:h-4/5 object-contain drop-shadow-lg shadow-white"
                alt="logo"
              />
            )}
        </Link>

        <div className="flex-1 relative">
          {/* Menu */}
          <menu
            className={`overflow-y-auto overflow-x-hidden h-[85vh] text-sm ${
              sideOpen ? "custom-scroll" : "scrollbar-hide"
            }`}
          >
            <Menu
              menu={admin ? menuAdmin : menuAgents}
              sideOpen={sideOpen}
              setSideOpen={setSideOpen}
              openHover={openHover}
              setOpenHover={setOpenHover}
            />
          </menu>
        </div>
      </aside>
    </Fragment>
  );
};

export default Sidebar;
